import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { DestinationDetailInitStepDeclaration } from "./Steps/DestinationDetailInitStep";

export const DestinationDetailStartupFlow = new FlowDefinition(
  "DestinationDetailFlow"
);

DestinationDetailStartupFlow.addStep(DestinationDetailInitStepDeclaration);

DestinationDetailStartupFlow.setStartStep("DestinationDetailInit_Step");

export const DestinationDetailStartupStepDefinition = new StepDefinition({
  stepName: "DestinationDetailFlow",
  stepFlow: DestinationDetailStartupFlow,
  contextIsolation: false,
});
